// extracted by mini-css-extract-plugin
export default {"container":"Header_container__IqMwP","logo":"Header_logo__ZDAhc","logoText":"Header_logoText__Sho+R","name":"Header_name__dAAwA","linkContainer":"Header_linkContainer__1fWpD"};